import { Button } from '@mui/material'
import { useMemo } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import { Page } from '../../components'
import { OutlinedBox } from '../../components/SharedUI'
import useAccessTokenAndShopId from '../../hooks/useAccessTokenAndShopId/useAccessTokenAndShopId'
import { AppRoutes } from '../../models'
import { useGetCannedJobExpandedQuery } from '../../redux/api/cannedJobApi'
import { CannedJobDetailContent } from './CannedJobDetailContent'

export default function CannedJobDetailPage() {
  const { id } = useParams()
  const { accessToken, shopId } = useAccessTokenAndShopId()
  const navigate = useNavigate()

  const { data: cannedJobs, isLoading } = useGetCannedJobExpandedQuery(
    {
      authorization: accessToken,
      shop: shopId,
      cannedJobs: [id!]
    },
    { skip: !id }
  )

  const cannedJob = useMemo(
    () => (cannedJobs ? cannedJobs[0] : undefined),
    [cannedJobs]
  )

  return (
    <Page title={cannedJob?.entry!.info!.name! || ''} isLoading={isLoading}>
      <Button
        onClick={() =>
          navigate(AppRoutes.SETTINGS_CANNED_JOBS)
        }>{`< Back`}</Button>
      {cannedJob && (
        <OutlinedBox title={cannedJob.entry!.info!.name!}>
          <CannedJobDetailContent cannedJob={cannedJob} />
        </OutlinedBox>
      )}
    </Page>
  )
}
